'use strict';

const base = require('brand_core/components/headerKeyboardNav');
const keyboardAccessibility = require('./keyboardAccessibility');

/**
 * keyboard events for secondary anchors inside open flyout menu
 */
base.secondaryNav = function () {
    keyboardAccessibility('.sitenav-secondary__li',
        {
            13: function () { // enter
                let $this = $(this);
                base.navigateLink(this);
                if ($this.children('ul').length) { // if there is a tertiary navigation
                    $this.find('li:visible').first().trigger('focus');
                }
                return true;
            },
            37: function () { // left
                $(this).closest('.sitenav-secondary__ul').prev('.sitenav-secondary__ul').find('li:visible')
                    .first()
                    .trigger('focus');
            },
            38: function (parentLi) { // up
                let $prevTertiaryitems = $(this).prev('li:visible').find('li:visible');

                if ($prevTertiaryitems.length) {
                    $prevTertiaryitems.last().trigger('focus');
                } else if ($(this).prevAll('li:visible').length) {
                    base.previousMenuItem(this);
                } else {
                    base.previousMenuLevel(parentLi);
                }
                return true;
            },
            39: function () { // right
                $(this).closest('.sitenav-secondary__ul').next('.sitenav-secondary__ul').find('li:visible')
                    .first()
                    .trigger('focus');
            },
            40: function () { // down
                const $currentFocusedEl = $(document.activeElement);
                let $nextTertiaryItems;

                if ($currentFocusedEl.hasClass('sitenav-secondary__li')) {
                    $nextTertiaryItems = $(this).find('.sitenav-secondary__a:visible');
                } else if ($currentFocusedEl.hasClass('sitenav-secondary__a')) {
                    $nextTertiaryItems = $(this).find('.sitenav-tertiary__a:visible');
                } else {
                    $nextTertiaryItems = $(this).next('a:visible');
                }

                if ($nextTertiaryItems.length) {
                    $nextTertiaryItems.first().trigger('focus');
                } else if ($(this).nextAll('li:visible').length) {
                    base.nextMenuItem(this);
                }
                return true;
            }
        },
        function () {
            return $(this).closest('.sitenav-primary__li');
        }
    );
};

/**
 * keyboard events for tertiary anchors inside open flyout menu
 */
base.tertiaryNav = function () {
    keyboardAccessibility('.sitenav-tertiary__a',
        {
            13: function () { // enter
                base.navigateLink(this);
                return true;
            },
            38: function () { // up
                const $prevItem = $(this).prev('a:visible');
                if ($prevItem.length) {
                    $prevItem.trigger('focus');
                } else {
                    $(this).closest('.sitenav-secondary__li').find('.sitenav-secondary__a').trigger('focus');
                }
                return true;
            },
            40: function () { // down
                const $nextItem = $(this).next('a:visible');

                if ($nextItem.length) {
                    $nextItem.trigger('focus');
                } else {
                    const $nextSecondaryInColumn = $(this).closest('.sitenav-secondary__li').next('li:visible');

                    if ($nextSecondaryInColumn.length) {
                        $nextSecondaryInColumn.find('.sitenav-secondary__a').first().trigger('focus');
                    }
                }
                return true;
            }
        },
        function () {
            return $(this).closest('.sitenav-secondary__li');
        }
    );
};

module.exports = base;
